export const sanitizePhoneNumber = (
  phoneNumber: string | undefined
): string => {
  if (!phoneNumber) return '';

  // Remove all non-digit characters
  const digitsOnly = phoneNumber.replace(/\D/g, '');

  // Ensure it's a valid phone number format (only digits)
  if (/^\d+$/.test(digitsOnly)) {
    return digitsOnly;
  }

  return '';
};

export const sanitizeUrl = (url: string | undefined): string => {
  if (!url) return '#';

  // Trim whitespace
  let sanitized = url.trim();

  // Add https:// if no protocol is specified
  if (!/^https?:\/\//i.test(sanitized)) {
    sanitized = 'https://' + sanitized;
  }

  // Validate URL format
  try {
    new URL(sanitized);
    // Only allow http and https protocols (schemes are case-insensitive)
    const lowercased = sanitized.toLowerCase();
    if (lowercased.startsWith('http://') || lowercased.startsWith('https://')) {
      return sanitized;
    }
  } catch (e) {
    // Invalid URL
    return '#';
  }

  return '#';
};
